import { ApiError } from '../errors/api-error.js';

export class ReportBrandingService {
    constructor(api) { this.api = api; }

    async get() { return this.#call(() => this.api.getCurrent()); }
    async update(data) { return this.#call(() => this.api.updateCurrent(data)); }
    async replaceLogo(file, expectedVersion) { return this.#call(() => this.api.replaceLogo(file, expectedVersion)); }
    async deleteLogo(expectedVersion) { return this.#call(() => this.api.deleteLogo(expectedVersion)); }

    async createDesignerCapability(data) { return this.#call(() => this.api.createDesignerCapability(data)); }

    async commitChrome(data) { return this.#call(() => this.api.commitChrome(data)); }

    async resetChrome(data) { return this.#call(() => this.api.resetChrome(data)); }
    async previewChrome(data) {
        return this.#call(() => this.api.previewChrome(data));
    }
    async getChromeSaveReceipt(editSessionId, saveId) {
        return this.#call(() => this.api.getChromeSaveReceipt(editSessionId, saveId));
    }

    async #call(operation) {
        try {
            const response = await operation();
            return {
                success: response.success ?? true,
                data: response.data ?? response,
                message: response.message,
            };
        } catch (error) {
            throw error instanceof ApiError ? error : new ApiError(error.message || 'Report branding request failed');
        }
    }
}
